import React from 'react';

import Email from './email';
import Phone from './phone';
import PWA from './pwa';
import Push from './push';

const Contact = () => {
  return (
    <>
      <div className="c-settings-section l-mt2">
        <div className="c-settings-section__column">
          <Email />
        </div>
        <div className="c-settings-section__column">
          <Phone />
        </div>
      </div>
      <div className="c-settings-section l-mt1 ">
        <div className="c-settings-section__column">
          <PWA />
        </div>
        <div className="c-settings-section__column">
          <Push />
        </div>
      </div>
    </>
  );
};

export default Contact;
